import React, {Component} from 'react';
import InsertAccountView from "./InsertAccountView";
import {Growl} from "primereact/growl";
import {MaintenanceAccountsService} from "../../../service/admin/maintenanceAccounts/MaintenanceAccountsService";
import {isValidData} from "../../../utils/validator/Fields";

export default class InsertAccountContainer extends Component {
    /**
     * Constructor de la clase, se inicializan las variables.
     * Se toma el elemento a editar que viene de la pantalla anterior.
     * @param {jmap} props Argumento que trae los valores iniciales de la clase
     *              Trae el elemento de la pantalla anterior para editar.
     */
    constructor(props) {
        super(props);
        this.maintenanceAccountsService = new MaintenanceAccountsService();

        this.state = {
            returnPath: this.props.location.state.returnPath,
            datosCuenta: {
                idInst: this.props.location.state.idInst,
                folioInst: this.props.location.state.folioInst,
                cuenta: '',
                descrCuenta: '',
                boveda: '',
                nombreCorto: '',
                cuentaEfectivo: '',
                banderaCuentaEfvo: '1',
                cuentaValorGSS: '',
                cuentaEfectivoGSS: '',
                efectivoCheck: false,
            },
            errorClass: 'p-error',
            errors: {
                cuenta: '',
                boveda: '',
                nombreCorto: '',
                descrCuenta: '',
            },
            isLoading: false,
            requiredFields: ['cuenta', 'descrCuenta', 'boveda', 'nombreCorto'],
        }

        this.getInfoNewAccount = this.getInfoNewAccount.bind(this);
        this.onChangeInputText = this.onChangeInputText.bind(this);
        this.onChangeSelectBox = this.onChangeSelectBox.bind(this);
        this.saveAccount = this.saveAccount.bind(this);
        this.validateErrors = this.validateErrors.bind(this);
        this.returnMaintenancePage = this.returnMaintenancePage.bind(this);
        this.loading = this.loading.bind(this);

        this.getInfoNewAccount();
    }

    /**
     * Función que setea la variable para que se vea la barra de carga
     */
    loading() {
        if (this.state !== undefined) {
            this.setState({
                isLoading: true
            });
        }
    }

    getInfoNewAccount(){
        this.loading();

        this.maintenanceAccountsService.getInfoNewAccount()
            .then(result => {
                this.setState({
                    datosCuenta: {
                        idInst: result.idInst,
                        folioInst: result.folioInst,
                        isLoading: false,
                        cuentasGSS: result.cuentasGSS,
                    },
                })
            })
    }

    /**
     * Función que maneja el cambio de valor en los campos de texto
     * y los coloca en el state dentro del objeto que se va a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeInputText(event) {
        const {name, value} = event.target;
        let datosCuenta = this.state.datosCuenta;
        datosCuenta[name] = value;
        this.setState({datosCuenta: datosCuenta,})
    }

    /**
     * Función que maneja el cambio de valor que se realice en el select
     * box que se muestra en la vista y coloca el valor en el state
     * dentro del objeto a editar.
     * @param event Contiene el valor que fue modificado en la vista.
     */
    onChangeSelectBox(event) {
        let datosCuenta = this.state.datosCuenta;
        event.checked ?
            datosCuenta['banderaCuentaEfvo'] = '2' :
            datosCuenta['banderaCuentaEfvo'] = '1';
        this.setState({
            efectivoCheck: event.checked,
            datosCuenta: datosCuenta,
        });
    }

    /**
     * Función que valida el map que contiene si los campos están llenos
     * si hay alguno que no esté lleno, regresa false, si no true.
     * @param {Map} Errors Map que contiene valores true o false de acuerdo
     *              a si está lleno.
     * @returns {boolean} Regresa un tue si todos entrán llenos
     */
    validateErrors(errors) {
        let result = false;

        for (let elem in errors) {
            if (this.state.datosCuenta[elem] === '') {
                result = true;
                return true;
            }
        }
        return result;
    }

    /**
     * Función que regresa a la pantalla de
     * Mantenimiento de cuentas y bóvedas.
     */
    returnMaintenancePage(response) {
        this.setState({isLoading: false,});

        this.props.history.push({
            pathname: this.state.returnPath,
            message: response,
        });
    }

    /**
     * Función que consume a MaintenanceAccountsService para guardar los datos
     * del elemento nuevo.
     * Se hace una validación que estén presentes los datos obligatorios.
     */
    saveAccount() {
        if (isValidData(this.state.requiredFields, this.state.datosCuenta)) {
            this.loading();
            this.maintenanceAccountsService.insertAccount(this.state.datosCuenta, this.state.cuentaValorGSS)
                .then(res => {
                    let messageObj = {};
                    if (res.message !== "") {
                        messageObj['severity'] = 'success';
                        messageObj['sumary'] = 'Éxito';
                        messageObj['detail'] = res.message;
                        this.returnMaintenancePage(messageObj)
                    } else if (res.error !== "") {
                        this.growl.show({severity: 'error', summary: 'Error.', detail: res.error});
                    }
                    this.loading(false);
                });
        } else {
            this.growl.show({severity: 'error', summary: 'Error.', detail: 'Llenar los campos requeridos'});
        }
    }

    /**
     * Función que realiza el render de la pantalla cuando existe un cambio.
     * En esta se le pasa a la vista lo que necesita para pintarse.
     * @returns {*}
     */
    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;
        const {datosCuenta, errorClass, errors, isLoading, efectivoCheck} = this.state

        return (
            <InsertAccountView datosCuenta={datosCuenta}
                               efectivoCheck={efectivoCheck}
                               onChangeInputText={this.onChangeInputText}
                               onChangeSelectBox={this.onChangeSelectBox}
                               messagesGrowl={messagesGrowl}
                               errorClass={errorClass}
                               errors={errors}
                               isLoading={isLoading}
                               returnMaintenancePage={this.returnMaintenancePage}
                               saveAccount={this.saveAccount}
            />
        );
    }
}
